// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactDOM from 'react-dom';
import DateTime from '../../common/DateTime/DateTime';
interface TimePickerProps extends React.PropsWithChildren<{}> {
    interval: number;
    onChange: (value: string) => void;
    value: string;
    timeFormat: string;
    id: string;
    className?: string;
    width?: string;
}

class TimePicker extends React.Component<TimePickerProps, any> {
    constructor(props: TimePickerProps) {
        super(props);

    }

    private _setOptions = (props: TimePickerProps) => {
        let container = $(this.refs[this.props.id]) as any;
        let displayTimeFormat = DateTime.getLocaleTimeFormat().replace(/a/g, "t"); // Syncfusion uses "tt" instead of "aa" for AM/PM
        let timeValue = (props.value) ? DateTime.convertTimeFormats(props.value, { srcTimeFormat: props.timeFormat }) : props.value;
        var options: any = {
            change: function () {
                let pickedValue = this.getValue();
                let newTimeValue = (pickedValue) ? DateTime.convertTimeFormats(pickedValue, { dstTimeFormat: props.timeFormat }) : pickedValue;
                props.onChange(newTimeValue);
            },
            interval: props.interval,
            timeFormat: displayTimeFormat,
            value: timeValue,
            cssClass: `time-picker ${this.props.className ? this.props.className : ''}`,
            locale: InovxLoader.getSyncfusionLocale()
        };

        if (props.width) {
            options.width = props.width;
        }

        container.ejTimePicker(options);
    }

    componentDidMount() {
        this._setOptions(this.props);
    }

    componentWillUnmount() {
        var timePicker = ($(ReactDOM.findDOMNode(this)) as any).data("ejTimePicker");
        timePicker.destroy();
    }

    render() {
        return <input type="text" id={this.props.id} ref={this.props.id} />;
    }

}

export default TimePicker;